module.exports = __webpack_public_path__ + "img/galeria_stack_3.7377ea2b.png";